'use strict';
define([
    'angular',
    'modules/keywordtracker/overview/overview.controller'
], function (angular, KeywordTrackerOverviewCtrl) {
    var app = angular.module('app.keywordtracker.overview', []);
    app.controller('KeywordTrackerOverviewCtrl', KeywordTrackerOverviewCtrl);
    return app;
});
